export default function Footer(){
    const now = new Date();
    const year = now.getFullYear();
    return (
        <div className="Footer">
            Miguel Angel {year}
        </div>
    );
} 